import moment, { type Moment } from 'moment'
import { useState } from 'react'

interface IDateField {
    name: string
    value: Moment
    placeholder: string
    error: string | null
    isTouched: boolean
}

export const useFields = () => {
    const initialDate = {
        name: 'date',
        value: moment(),
        placeholder: 'Введите дату',
        error: null,
        isTouched: false
    }

    const [date, setDate] = useState<IDateField>(initialDate)

    const onChangeDate = (e: Moment) => setDate((prev) => ({ ...prev, value: e }))

    return {
        date,
        onChangeDate
    }
}
